<template lang="pug">
  .kol-list-item(
    :class="{'is__blacklist': data.in_blacklist === 1}"
  )
    .kol-list-item__left
      .kol-list-item__avatar
        img(
          v-if="data.avatar_url != null"
          :src="data.avatar_url"
        )
        img(
          v-else
          src="@/umcc/assets/default_avatar.png"
        )
      .kol-list-item__name
        .item__title(@click="handleViewKol")
          el-tooltip(
            v-if="data.kol_name.length > 10 && window.width < 1500"
            :content="data.kol_name"
          )
            span.title_show_tooltip {{ data.kol_name }}
          template(v-else)
            span {{ data.kol_name }}
          span(v-if="listType === 'wechat'") {{ $t(data.kol_type) }}
          template(v-else)
            i.iconfont.icon-renzheng(
              :v-if="data.kol_type === '个人认证'"
              style="color: #FFC174"
            )
            i.iconfont.icon-renzheng(
              :v-if="data.kol_type === '机构认证'"
              style="color: #1890FF"
            )
        .item__id
          span(v-if="listType === 'wechat'") {{ $t('微信号') }}:
          span(v-else) {{ $t('微博号') }}:
          span {{ data.kol_external_id }}
        .item__brand(v-if="window.width < 1600 && data.brand.length !== 0")
          span(v-if="data.brand.length !== 0").item__brand__item {{ data.brand[0].brand }}
          span(v-if="data.brand.length > 1").item__brand__item +{{ data.brand.length - 1 }}
        .item__brand(v-if="window.width > 1600 && data.brand.length !== 0")
          span.item__brand__item(
            v-for="(item, index) in data.brand.slice(0,3)"
          ) {{ item.brand }}
          span(v-if="data.brand.length > 3").item__brand__item +{{ data.brand.length - 3 }}
    .kol-list-item__divider
    .kol-list-item__center(
      :style="{minWidth: isEn ? '485px' : '465px'}"
    )
      div
        .item__social__number(style="width: 115px")
          div
            i.iconfont.icon-fensishu
            span {{ $t('预估粉丝数') }}
          span {{ data.fans | numberWithCommas }}
        .item__center__divider
        .item__social__number(
          v-if="listType === 'wechat'"
          :style="{width: isEn ? '150px' : '120px'}"
        )
          div
            i.iconfont.icon-yuedu
            span {{ $t('平均阅读数') }}
          span {{ data.avg_views | numberWithCommas }}
        .item__social__number(
          :style="{width: isEn ? '150px' : '120px'}"
          v-else
        )
          div
            i.iconfont.icon-yuedu
            span {{ $t('平均转发数') }}
          span {{ data.avg_repost | numberWithCommas }}
        .item__center__divider
        .item__social__number(:style="{width: isEn ? '150px' : '132px'}")
          div
            i.iconfont.icon-iconfontzhizuobiaozhun44
            span {{ $t('平均点赞数') }}
          span {{ data.avg_likes | numberWithCommas }}
    .kol-list-item__divider
    .kol-list-item__right
      span ￥
      span {{ data.price | numberWithCommas }}
      span {{ $t('起') }}
</template>
<script>
import db from '@/umcc/db'

export default {
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    listType: {
      type: String,
      default () {
        return 'wechat'
      }
    }
  },
  data () {
    return {
      window: {
        width: 0,
        height: 0
      }
    }
  },
  computed: {
    isEn () {
      return db.lang === 'en'
    }
  },
  filters: {
    numberWithCommas (v) {
      if (!v || Number.isNaN(v)) return 0
      return Number(v).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  methods: {
    handleViewKol () {
      this.$router.push('/kol-info')
      this.$store.commit('kol/setKolId', this.data.kol_id)
      this.$store.commit('kol/setKolName', this.data.kol_name)
      this.$store.commit('kol/setKolChannel', this.listType)
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="stylus">
.kol-list-item
  border-bottom 1px solid #ebebeb
  padding 24px 32px
  display flex
  align-items center
  &:hover
    background-color #f2f7ff !important
    img
      border-color $main !important
  .kol-list-item__left
    width 45%
    display flex
    align-items center
    .kol-list-item__avatar
      width 88px
      height 88px
      margin-right 24px
      img
        width 88px
        height 88px
        border-radius 50%
        border 1px solid #cccccc
        cursor pointer
    .kol-list-item__name
      .item__title
        display flex
        align-items center
        margin-bottom 8px
        cursor pointer
        span
          display inline-block
          &:nth-child(1)
            color #2c3031
            font-size 22px
            height 30px
            line-height 30px
          &:nth-child(2)
            height 22px
            border-radius 11px
            background-color #5f99f6
            line-height 22px
            padding 0px 12px
            color #ffffff
            font-weight 300
            font-size 12px
            text-align center
            margin-left 10px
        .iconfont
          margin-left 10px
        .title_show_tooltip
          width 180px
          overflow hidden
          text-overflow ellipsis
          white-space nowrap
      .item__id
        margin-bottom 10px
        span
          &:nth-child(1)
            color #5e5e5e
            margin-right 10px
          &:nth-child(2)
            color #808080
      .item__brand
        height 22px
        line-height 22px
        .item__brand__item
          border-radius 4px
          border solid 1px #5f99f6
          background-color #edf2fa
          color #5f99f6
          padding 0 5px
          margin-right 8px
  .kol-list-item__center
    > div
      display flex
      margin 0 32px
      justify-content space-between
    .item__social__number
      text-align right
      > div
        height 20px
        margin-bottom 10px
        .iconfont
          margin-right 8px
          color #8c8c8c
        span
          color #2c3031
      > span
        color $main
        font-size 22px
        height 30px
        line-height 30px
    .item__center__divider
      height 13px
      margin 0 24px
      border-right 1px solid #e8e8e8
  .kol-list-item__right
    width 15%
    text-align right
    span
      &:nth-child(2)
        font-size 26px
      &:nth-child(3)
        color #5e5e5e
        margin-left 8px
  .kol-list-item__divider
    height 56px
    border-right solid 1px #e8e8e8
.kol-list-item.is__blacklist
  background-color #f7f7f7
  background-image url(../assets/blacklist.jpg)
  background-repeat no-repeat
  background-position right bottom
  background-size 124px 116px
</style>
